import axios from "axios";
import { BASEURL } from "../../baseUrl";
import { toast } from "react-toastify";

export const ADD_ACCOUNT = 'ADD_ACCOUNT';
export const UPDATE_ACCOUNT = 'UPDATE_ACCOUNT';
export const GET_ACCOUNT = 'GET_ACCOUNT';
export const DELETE_ACCOUNT = 'DELETE_ACCOUNT';
export const SEARCH_ACCOUNT = 'SEARCH_ACCOUNT';
export const ADD_HSN = 'ADD_HSN';
export const UPDATE_HSN = 'UPDATE_HSN';
export const GET_HSN = 'GET_HSN';
export const DELETE_HSN = 'DELETE_HSN';
export const SEARCH_HSN = 'SEARCH_HSN';
export const ADD_PRODUCT = 'ADD_PRODUCT';
export const UPDATE_PRODUCT = 'UPDATE_PRODUCT';
export const GET_PRODUCT = 'GET_PRODUCT';
export const DELETE_PRODUCT = 'DELETE_PRODUCT';
export const SEARCH_PRODUCT = 'SEARCH_PRODUCT';
export const ADD_DOCTOR = 'ADD_DOCTOR';
export const UPDATE_DOCTOR = 'UPDATE_DOCTOR';
export const GET_DOCTOR = 'GET_DOCTOR';
export const DELETE_DOCTOR = 'DELETE_DOCTOR';
export const SEARCH_DOCTOR = 'SEARCH_DOCTOR';
export const ADD_PATIENT = 'ADD_PATIENT';
export const UPDATE_PATIENT = 'UPDATE_PATIENT';
export const GET_PATIENT = 'GET_PATIENT';
export const DELETE_PATIENT = 'DELETE_PATIENT';
export const SEARCH_PATIENT = 'SEARCH_PATIENT';
export const ADD_BATCH = 'ADD_BATCH';
export const UPDATE_BATCH = 'UPDATE_BATCH';
export const GET_BATCH = 'GET_BATCH';
export const DELETE_BATCH = 'DELETE_BATCH';
export const SEARCH_BATCH = 'SEARCH_BATCH';
export const ADD_ABOUT = 'ADD_ABOUT';
export const UPDATE_ABOUT = 'UPDATE_ABOUT';
export const GET_ABOUT = 'GET_ABOUT';
export const DELETE_ABOUT = 'DELETE_ABOUT';

export const ADMIN_USER = 'ADMIN_USER';
export const ADMIN_GET = 'ADMIN_GET';
export const ADMIN_UPDATE = 'ADMIN_UPDATE';
export const ADMIN_DELETE = 'ADMIN_DELETE';

export const HSN_DROPDOWN = 'HSN_DROPDOWN';
export const PRODUCT_DROPDOWN = 'PRODUCT_DROPDOWN';
export const PARTY_DROPDOWN = 'PARTY_DROPDOWN';

const accountAddAction = (payload) => ({ type: ADD_ACCOUNT, payload: payload });
const accountUpdateAction = (payload) => ({ type: UPDATE_ACCOUNT, payload: payload });
const accountGetAction = (payload) => ({ type: GET_ACCOUNT, payload: payload });
const accountDeleteAction = (payload) => ({ type: DELETE_ACCOUNT, payload: payload });
const accountSearchAction = (payload) => ({ type: SEARCH_ACCOUNT, payload: payload });
const hsnAddAction = (payload) => ({ type: ADD_HSN, payload: payload });
const hsnUpdateAction = (payload) => ({ type: UPDATE_HSN, payload: payload });
const hsnGetAction = (payload) => ({ type: GET_HSN, payload: payload });
const hsnDeleteAction = (payload) => ({ type: DELETE_HSN, payload: payload });
const hsnSearchAction = (payload) => ({ type: SEARCH_HSN, payload: payload });
const productAddAction = (payload) => ({ type: ADD_PRODUCT, payload: payload });
const productUpdateAction = (payload) => ({ type: UPDATE_PRODUCT, payload: payload });
const productGetAction = (payload) => ({ type: GET_PRODUCT, payload: payload });
const productDeleteAction = (payload) => ({ type: DELETE_PRODUCT, payload: payload });
const productSearchAction = (payload) => ({ type: SEARCH_PRODUCT, payload: payload });
const doctorAddAction = (payload) => ({ type: ADD_DOCTOR, payload: payload });
const doctorUpdateAction = (payload) => ({ type: UPDATE_DOCTOR, payload: payload });
const doctorGetAction = (payload) => ({ type: GET_DOCTOR, payload: payload });
const doctorDeleteAction = (payload) => ({ type: DELETE_DOCTOR, payload: payload });
const doctorSearchAction = (payload) => ({ type: SEARCH_DOCTOR, payload: payload });
const patientAddAction = (payload) => ({ type: ADD_PATIENT, payload: payload });
const patientUpdateAction = (payload) => ({ type: UPDATE_PATIENT, payload: payload });
const patientGetAction = (payload) => ({ type: GET_PATIENT, payload: payload });
const patientDeleteAction = (payload) => ({ type: DELETE_PATIENT, payload: payload });
const patientSearchAction = (payload) => ({ type: SEARCH_PATIENT, payload: payload });
const batchAddAction = (payload) => ({ type: ADD_BATCH, payload: payload });
const batchUpdateAction = (payload) => ({ type: UPDATE_BATCH, payload: payload });
const batchGetAction = (payload) => ({ type: GET_BATCH, payload: payload });
const batchDeleteAction = (payload) => ({ type: DELETE_BATCH, payload: payload });
const batchSearchAction = (payload) => ({ type: SEARCH_BATCH, payload: payload });
const addAboutAction = (payload) => ({ type: ADD_ABOUT, payload: payload });
const updateAboutAction = (payload) => ({ type: UPDATE_ABOUT, payload: payload });
const getAboutAction = (payload) => ({ type: GET_ABOUT, payload: payload });
const deleteAboutAction = (payload) => ({ type: DELETE_ABOUT, payload: payload });

const adminUserAction = (payload) => ({ type: ADMIN_USER, payload: payload });
const adminGetAction = (payload) => ({ type: ADMIN_GET, payload: payload });
const adminUpdateAction = (payload) => ({ type: ADMIN_UPDATE, payload: payload });
const adminDeleteAction = (payload) => ({ type: ADMIN_DELETE, payload: payload });

const hsnDropdownAction = (payload) => ({ type: HSN_DROPDOWN, payload: payload });
const productDropdownAction = (payload) => ({ type: PRODUCT_DROPDOWN, payload: payload });
const partyDropdownAction = (payload) => ({ type: PARTY_DROPDOWN, payload: payload });

export const addAdmin = (payload, limits) => {
    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/auth/register`, payload).then(((res) => {
                toast.success('Add Admin User successfully')
                dispatch(adminUserAction(res));
                dispatch(getAdmin(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(adminUserAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const getAdmin = () => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/auth/viewAuth`).then(((res) => {
                dispatch(adminGetAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(adminGetAction(error?.response));
            });
        } catch (error) {
            console.log('Erro File Create', error);
        }
    }
}

export const updateAdmin = (payload, limits) => {
    return async (dispatch) => {
        try {
            await axios.put(`${BASEURL}/auth/updateAuth`, payload).then(((res) => {
                toast.success('Update Auth successfully')
                dispatch(adminUpdateAction(res));
                dispatch(getAdmin(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(adminUpdateAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const deleteAdmin = (problemId, limits) => {
    return async (dispatch) => {
        try {
            await axios.delete(`${BASEURL}/auth/deleteAuth/${problemId}`).then(((res) => {
                toast.success('Delete Auth successfully')
                dispatch(adminDeleteAction(res));
                dispatch(getAdmin(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(adminDeleteAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const addAccount = (payload, limits) => {
    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/master/registerParty`, payload).then(((res) => {
                toast.success('Add Account successfully')
                dispatch(accountAddAction(res));
                dispatch(getAccount(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(accountAddAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const getAccount = (payload) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/viewAllParties?limit=${payload.limit}&page=${payload.page}`).then(((res) => {
                dispatch(accountGetAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(accountGetAction(error?.response));
            });
        } catch (error) {
            console.log('Erro File Create', error);
        }
    }
}

export const updateAccount = (payload, limits, ids) => {
    return async (dispatch) => {
        try {
            await axios.put(`${BASEURL}/master/updateParty/${ids}`, payload).then(((res) => {
                toast.success('Update Account successfully')
                dispatch(accountUpdateAction(res));
                dispatch(getAccount(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(accountUpdateAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const deleteAccount = (problemId, limits) => {
    return async (dispatch) => {
        try {
            await axios.delete(`${BASEURL}/master/deleteParty/${problemId}`).then(((res) => {
                toast.success('Delete Account successfully')
                dispatch(accountDeleteAction(res));
                dispatch(getAccount(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(accountDeleteAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const searchAccount = (queryParams) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/search-party?limit=10&${queryParams}`).then(((res) => {
                dispatch(accountSearchAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(accountSearchAction(error?.response));
            });
        } catch (error) {
            console.log('Erro File Create', error);
        }
    }
}

export const addHsn = (payload, limits) => {
    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/master/registerHSN`, payload).then(((res) => {
                toast.success('Add Hsn successfully')
                dispatch(hsnAddAction(res));
                dispatch(getHsn(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(accountAddAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const getHsn = (payload) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/viewAllHSN?limit=${payload.limit}&page=${payload.page}`).then(((res) => {
                dispatch(hsnGetAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(hsnGetAction(error?.response));
            });
        } catch (error) {
            console.log('Erro File Create', error);
        }
    }
}

export const updateHsn = (payload, limits, ids) => {
    return async (dispatch) => {
        try {
            await axios.put(`${BASEURL}/master/updateHSN/${ids}`, payload).then(((res) => {
                toast.success('Update Hsn successfully')
                dispatch(hsnUpdateAction(res));
                dispatch(getHsn(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(hsnUpdateAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const deleteHsn = (problemId, limits) => {
    return async (dispatch) => {
        try {
            await axios.delete(`${BASEURL}/master/deleteHSN/${problemId}`).then(((res) => {
                toast.success('Delete Hsn successfully')
                dispatch(hsnDeleteAction(res));
                dispatch(getHsn(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(hsnDeleteAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const searchHsn = (queryParams) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/search-HSN?limit=10&${queryParams}`).then(((res) => {
                dispatch(hsnSearchAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(hsnSearchAction(error?.response));
            });
        } catch (error) {
            console.log('Erro File Create', error);
        }
    }
}

export const addProduct = (payload, limits) => {
    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/master/registerProduct`, payload).then(((res) => {
                toast.success('Add Product successfully')
                dispatch(productAddAction(res));
                dispatch(getProduct(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(productAddAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const getProduct = (payload) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/viewAllProducts?limit=${payload.limit}&page=${payload.page}`).then(((res) => {
                dispatch(productGetAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(productGetAction(error?.response));
            });
        } catch (error) {
            console.log('Erro File Create', error);
        }
    }
}

export const updateProduct = (payload, limits, ids) => {
    return async (dispatch) => {
        try {
            await axios.put(`${BASEURL}/master/updateProduct/${ids}`, payload).then(((res) => {
                toast.success('Update Product successfully')
                dispatch(productUpdateAction(res));
                dispatch(getProduct(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(productUpdateAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const deleteProduct = (problemId, limits) => {
    return async (dispatch) => {
        try {
            await axios.delete(`${BASEURL}/master/deleteProduct/${problemId}`).then(((res) => {
                toast.success('Delete Product successfully')
                dispatch(productDeleteAction(res));
                dispatch(getProduct(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(productDeleteAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const searchProduct = (queryParams) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/search-Product?limit=10&${queryParams}`).then(((res) => {
                dispatch(productSearchAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(productSearchAction(error?.response));
            });
        } catch (error) {
            console.log('Erro File Create', error);
        }
    }
}

export const addDoctor = (payload, limits) => {
    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/master/registerDoctor`, payload).then(((res) => {
                toast.success('Add Doctor successfully')
                dispatch(doctorAddAction(res));
                dispatch(getDoctor(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(doctorAddAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const getDoctor = (payload) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/viewAllDoctors?limit=${payload.limit}&page=${payload.page}`).then(((res) => {
                dispatch(doctorGetAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(doctorGetAction(error?.response));
            });
        } catch (error) {
            console.log('Erro File Create', error);
        }
    }
}

export const updateDoctor = (payload, limits, ids) => {
    return async (dispatch) => {
        try {
            await axios.put(`${BASEURL}/master/updateDoctor/${ids}`, payload).then(((res) => {
                toast.success('Update Doctor successfully')
                dispatch(doctorUpdateAction(res));
                dispatch(getDoctor(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(doctorUpdateAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const deleteDoctor = (problemId, limits) => {
    return async (dispatch) => {
        try {
            await axios.delete(`${BASEURL}/master/deleteDoctor/${problemId}`).then(((res) => {
                toast.success('Delete Product successfully')
                dispatch(doctorDeleteAction(res));
                dispatch(getDoctor(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(doctorDeleteAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const searchDoctor = (queryParams) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/search-Doctor?limit=10&${queryParams}`).then(((res) => {
                dispatch(doctorSearchAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(doctorSearchAction(error?.response));
            });
        } catch (error) {
            console.log('Erro File Create', error);
        }
    }
}

export const addPatient = (payload, limits) => {
    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/master/registerPatient`, payload).then(((res) => {
                toast.success('Add Patient successfully')
                dispatch(patientAddAction(res));
                dispatch(getPatient(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(patientAddAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const getPatient = (payload) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/viewAllPatients?limit=${payload.limit}&page=${payload.page}`).then(((res) => {
                dispatch(patientGetAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(patientGetAction(error?.response));
            });
        } catch (error) {
            console.log('Erro File Create', error);
        }
    }
}

export const updatePatient = (payload, limits, ids) => {
    return async (dispatch) => {
        try {
            await axios.put(`${BASEURL}/master/updatePatient/${ids}`, payload).then(((res) => {
                toast.success('Update Patient successfully')
                dispatch(patientUpdateAction(res));
                dispatch(getPatient(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(patientUpdateAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const deletePatient = (problemId, limits) => {
    return async (dispatch) => {
        try {
            await axios.delete(`${BASEURL}/master/deletePatient/${problemId}`).then(((res) => {
                toast.success('Delete Patient successfully')
                dispatch(patientDeleteAction(res));
                dispatch(getPatient(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(patientDeleteAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const searchPatient = (queryParams) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/searchPatient?search=${queryParams}`).then(((res) => {
                dispatch(patientSearchAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(patientSearchAction(error?.response));
            });
        } catch (error) {
            console.log('Erro File Create', error);
        }
    }
}

export const addBatch = (payload, limits) => {
    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/master/registerBatch`, payload).then(((res) => {
                toast.success('Add Batch Successfully')
                dispatch(batchAddAction(res));
                dispatch(getBatch(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(batchAddAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const getBatch = (payload) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/viewAllBatches?limit=${payload.limit}&page=${payload.page}`).then(((res) => {
                dispatch(batchGetAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(batchGetAction(error?.response));
            });
        } catch (error) {
            console.log('Erro File Create', error);
        }
    }
}

export const updateBatch = (payload, limits, ids) => {
    return async (dispatch) => {
        try {
            await axios.put(`${BASEURL}/master/updateBatch/${ids}`, payload).then(((res) => {
                toast.success('Update Batch successfully')
                dispatch(batchUpdateAction(res));
                dispatch(getBatch(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(batchUpdateAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const deleteBatch = (problemId, limits) => {
    return async (dispatch) => {
        try {
            await axios.delete(`${BASEURL}/master/deleteBatch/${problemId}`).then(((res) => {
                toast.success('Delete Batch Successfully')
                dispatch(batchDeleteAction(res));
                dispatch(getBatch(limits))
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(batchDeleteAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const searchBatch = (queryParams) => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/searchBatch?limit=10&${queryParams}`).then(((res) => {
                dispatch(batchSearchAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(batchSearchAction(error?.response));
            });
        } catch (error) {
            console.log('Erro File Create', error);
        }
    }
}

export const addAbout = (payload) => {
    return async (dispatch) => {
        try {
            await axios.post(`${BASEURL}/master/register-about`, payload).then(((res) => {
                toast.success('Add About Successfully')
                dispatch(addAboutAction(res));
                dispatch(getAbout())
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(addAboutAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const getAbout = () => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/get-all-about`).then(((res) => {
                dispatch(getAboutAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(getAboutAction(error?.response));
            });
        } catch (error) {
            console.log('Erro File Create', error);
        }
    }
}

export const updateAbout = (payload, ids) => {
    return async (dispatch) => {
        try {
            await axios.put(`${BASEURL}/master/update-about/${ids}`, payload).then(((res) => {
                toast.success('Update About successfully')
                dispatch(updateAboutAction(res));
                dispatch(getAbout())
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(updateAboutAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}

export const deleteAbout = (problemId, limits) => {
    return async (dispatch) => {
        try {
            await axios.delete(`${BASEURL}/master/delete-about/${problemId}`).then(((res) => {
                toast.success('Delete About Successfully')
                dispatch(deleteAboutAction(res));
                dispatch(getAbout())
            })).catch((error) => {
                console.log("Error", error);
                toast.error(error?.response?.data?.message)
                dispatch(deleteAboutAction(error?.response));
            });
        } catch (error) {
            toast.error(error?.response)
            console.log('Erro File Create', error);
        }
    }
}


// dropdown
export const hsnDropdown = () => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/getAllHSNCodes`).then(((res) => {
                dispatch(hsnDropdownAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(hsnDropdownAction(error?.response));
            });
        } catch (error) {
            console.log('Erro File Create', error);
        }
    }
}

export const productDropdown = () => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/getAllProducts`).then(((res) => {
                dispatch(productDropdownAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(productDropdownAction(error?.response));
            });
        } catch (error) {
            console.log('Erro File Create', error);
        }
    }
}

export const partyDropdown = () => {
    return async (dispatch) => {
        try {
            await axios.get(`${BASEURL}/master/getAllParties`).then(((res) => {
                dispatch(partyDropdownAction(res));
            })).catch((error) => {
                console.log("Error", error);
                dispatch(partyDropdownAction(error?.response));
            });
        } catch (error) {
            console.log('Erro File Create', error);
        }
    }
}